import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { Resources } from "../models/resources";
import { HttpClient } from "@angular/common/http";
import { ResourcesService } from "./resources.service";
import { map } from "rxjs/operators";


interface version_payload {
  name: string
  version: number
}
@Injectable({
  providedIn: "root",
})
export class VersionsService {
  
  BASE_API = environment.urlAPI;

  /***** DATA *****/
  public total_versions: number = 0;
  public lastEvaluatedKey: any;

 /***** FLAGS *****/
  public itemsPerPage: number = 10;
  public currentPage: number = 1;

  constructor(
    private http: HttpClient,
  ) {}

  getVersion(resource_id: string,version_number: number, owner_id: string, currentVersion: number): Observable<{ valid: boolean; data: Resources }> {
    
    if (!version_number) return;

    const params: Partial<any> = {
      resource_id: `"${resource_id}"`,
    };
        
    if (version_number != currentVersion) {
      params.version_number = version_number;
    }

    return this.http.get(`${this.BASE_API}/users/${owner_id}/resources`,{ params })
      .pipe(
        map((response: any) => {
          const { status, data } = response;
          if (status) {
            return { valid: true, data };
          } else {
            return { valid: false, data: null };
          }
        })
      );
  }


  deleteVersion(resource_id: string, version_number: number): Observable<any>{
    if(!version_number) return;

    return this.http.delete(`${this.BASE_API}/resources/"${resource_id}"/v/${version_number}`)
      .pipe(
        map((response: any) => {
          const { status } = response;
          if (status) {
            return { valid: true };
          } else {
            return { valid: false };
          }
        })
      );
  }


  /**
   * @param resource_id
   * @param version_number
   */
  createVersion(resource_id: string, payload: version_payload, owner_id: string): Observable<{ valid: boolean; data: Resources }> {
    const { version, name } = payload;
    return this.http
      .post(`${this.BASE_API}/users/"${owner_id}"/resources/"${resource_id}"/v/${version}?name="${name}"`, null)
      .pipe(
        map((response: any) => {
          let { status, data } = response;
          if (status) {
            return { valid: true, data };
          } else {
            return { valid: false, data: null };
          }
        })
      );
  }
}
